export default {
  install (Vue, store) {
    Vue.prototype.$t = key => {
      return store.getters['base/translations/getByKey'](key)
    }
  }
}
